import React, {FC} from 'react';
import styled from 'styled-components';
import {ExtendedLiveShoppingSection} from '../../../types';
import {LiveSection} from './LiveSection';

const StyledArticle = styled.article`
  max-width: 1100px;
  margin: 0 auto;
`;

export const LiveSections: FC<{sections: ExtendedLiveShoppingSection[]}> = ({
  sections,
}) => {
  if (sections.length === 0) {
    return null;
  }

  return (
    <StyledArticle>
      {sections.map(section => (
        <LiveSection key={section.title} section={section} />
      ))}
    </StyledArticle>
  );
};
